const BLdetailstable = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "BLFilingCode",
    label: "备案号",
    columnwidth: 180,
  },
  {
    prop: "BLCompanyName",
    label: "企业名称",
    columnwidth: 310,
  },
  {
    prop: "BLBusinessMode",
    label: "驳回时间",
    columnwidth: 130,
  },
  {
    prop: "BLBusinessMode",
    label: "经营方式",
    columnwidth: 180,
  },
  {
    prop: "BLAddress",
    label: "住所",
    columnwidth: 220,
  },
  {
    prop: "BLBusinessAddr",
    label: "经营场所",
    columnwidth: 130,
  },
  {
    prop: "BLWarehouseAddr",
    label: "库房地址",
    columnwidth: 180,
  },
  {
    prop: "BLLegalRepresentative",
    label: "法定代表人",
    columnwidth: 220,
  },
  {
    prop: "BLCEO",
    label: "企业负责人",
    columnwidth: 130,
  },
  {
    prop: "BLSecInvSort",
    label: "二类经营范围",
    columnwidth: 180,
  },
  {
    prop: "BLFilingDate",
    label: "备案日期",
    columnwidth: 220,
  },
  {
    prop: "BLPhoto",
    label: "第二类医疗器械经营备案凭证照片文件名",
    columnwidth: 130,
  },
  {
    prop: "BLPhotoURL",
    label: "图片显示地址",
    columnwidth: 180,
  },
  {
    prop: "Status",
    label: "状态",
    columnwidth: 220,
  },
  {
    prop: "RejectReason",
    label: "驳回原因",
    columnwidth: 130,
  },
  {
    prop: "CreateTime",
    label: "提交时间",
    columnwidth: 180,
  },
  {
    prop: "VerifyTime",
    label: "审核时间",
    columnwidth: 220,
  },
  {
    prop: "RejectTime",
    label: "驳回时间",
    columnwidth: 220,
  },
];
export default BLdetailstable;
